<template>
  <div class="productImageItem">
    <div class="productWrapper">
      <div class="product">
        <div class="productInner">
          <AdvancedImage
            :is-lazy-component="false"
            :src="product.src"
            :alt="product.alt"
            :config="productConfig"
            modifier="centered"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvancedImage from 'Components/01-atoms/advanced-image/AdvancedImage';

export default {
  name: 'ProductImageItem',
  components: { AdvancedImage },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      productConfig: {
        q: 80,
        w: 500,
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.productImageItem {
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productWrapper {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
}

.product {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productInner {
  height: 100%;
  width: 100%;
}
</style>
